import {authHeader} from '../_helpers'
import axios from 'axios'
import {API_URL} from './user.service'
// import {router as r} from '../router'

export const outreachService = {
  save,
  load,
  update
}

async function save (data, type) {
    return  axios.post(
      `${API_URL}/api/reports/${type}`,
      data,
      {headers: authHeader()}
    ).then(res => res)
}
async function update (data, reportId, type ) {
  return axios.put(
    `${API_URL}/api/reports/${type}/${reportId}`,
      data,
      {headers: authHeader()}
  ).then(res => res)
}
async function load (reportId, type) {
  const resp = await axios.get(  `${API_URL}/api/reports/${type}/${reportId}`,
    {headers: authHeader()}
  )
  return resp.data
}



// WEBPACK FOOTER //
// ./src/_services/outreach.service.js